import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/t/users')({
  staticData: { breadcrumb: 'Users', breadcrumbKey: 'K_BREADCRUMB_USERS' },
  component: UsersLayout,
});

function UsersLayout() {
  return <Outlet />;
}
